import {alpha} from "@mui/material/styles";
import type {Theme} from "@mui/material/styles";
import {printoutPalette} from "../../core/printoutPalette";

export const PRINTOUT_DRAG_ATTRIBUTE = "data-printout-dragging";
export const PRINTOUT_COLUMN_DROP_ATTRIBUTE = "data-printout-drop-target";

// Outlines and overlays do not change document dimensions or move the target during a drag.
export const printoutDragFeedbackSx = (theme: Theme) => ({
    [`& .printout-tiptap-editor[${PRINTOUT_DRAG_ATTRIBUTE}]`]: {
        '--printout-drag-chrome-opacity': 1,
        '& .printout-block-dash rect': {
            strokeDasharray: 'none',
        },
        '& .printout-block-menu, & .printout-variable-menu': {
            visibility: 'hidden',
            pointerEvents: 'none',
        },
        '& .printout-container-column': {
            borderRadius: '2px',
            outline: `1px dashed ${printoutPalette.border}`,
            outlineOffset: '3px',
        },
        [`& .printout-container-column[${PRINTOUT_COLUMN_DROP_ATTRIBUTE}]`]: {
            bgcolor: alpha(theme.palette.primary.main, 0.04),
            outline: `2px solid ${theme.palette.primary.main}`,
        },
    },
    '& .printout-drop-cursor': {
        bgcolor: 'primary.main',
        borderRadius: 999,
    },
});
